import {createApi} from '@reduxjs/toolkit/query/react';
import {
  IStep,
  allOPModels,
  allRoles,
  IOperatingModel,
  IMilestone,
  ITraining,
  IProcess,
  IProcessDetails,
  IProcessMap,
  IPhase,
} from 'app/types/Shared';

import {baseQuery} from 'app/helpers/auth';

export const omApi = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: ['IOperatingModel'],
  endpoints(builder) {
    return {
      getAllOpModels: builder.query<Array<allOPModels>, void>({
        query: () => {
          return {
            url: '/operatingModels',
            method: 'GET',
          };
        },
      }),
      getMilestones: builder.query<Array<IMilestone>, void>({
        query: () => {
          return {
            url: '/milestones',
            method: 'GET',
          };
        },
      }),
      getAllProcesses: builder.query<Array<IProcess>, void>({
        query: () => {
          return {
            url: '/processes',
            method: 'GET',
          };
        },
      }),
      getAllTrainings: builder.query<Array<ITraining>, void>({
        query: () => {
          return {
            url: '/trainings',
            method: 'GET',
          };
        },
      }),
      getAllSteps: builder.query<Array<IStep>, void>({
        query: () => {
          return {
            url: '/steps',
            method: 'GET',
            credentials: 'same-origin',
          };
        },
      }),
      getAllRoles: builder.query<allRoles, void>({
        query: () => {
          return {
            url: '/roles',
            method: 'GET',
          };
        },
      }),
      getOpModelById: builder.query<IOperatingModel, number>({
        query: (id) => {
          console.log('FETCHING OPERATING MODEL :: ' + id);
          return {
            url: `operatingModel/${id}`,
            method: 'GET',
          };
        },
      }),
      getAllMaps: builder.query<Array<IProcessMap>, void>({
        query: () => {
          return {
            url: '/maps',
            method: 'GET',
          };
        },
      }),
      getAllPhases: builder.query<Array<IPhase>, void>({
        query: () => {
          return {
            url: '/phases',
            method: 'GET',
          };
        },
      }),
      getProcessStepsById: builder.query<IProcessDetails, number>({
        query: (id) => {
          return {
            url: `process/${id}`,
            method: 'GET',
          };
        },
      }),
    };
  },
});

export const {
  useGetOpModelByIdQuery,
  useGetAllStepsQuery,
  useGetAllOpModelsQuery,
  useGetMilestonesQuery,
  useGetAllTrainingsQuery,
  useGetAllProcessesQuery,
  useGetAllMapsQuery,
  useGetProcessStepsByIdQuery,
} = omApi;
